// Clamp non-emissive colors (think bright reflective sections of metallic dice)
// so that only the elevated emissive colors are picked up by the bloom pass

vec3 nonEmissive = max(gl_FragColor.rgb - totalEmissiveRadiance, vec3(0.0));
nonEmissive = min(nonEmissive, 0.99);

gl_FragColor.rgb = nonEmissive + totalEmissiveRadiance;
